/**
 * What the tenant picker offers when a tenant refuses entry for want of a
 * second factor.
 *
 * The sign-in screen asks for a code only at password time, so a session that
 * began before its account enrolled (a cookie from yesterday, an enrolment done
 * in another browser) reaches the picker enrolled but unsatisfied. The picker
 * used to offer enrolment only to the unenrolled and a message to everyone
 * else — "sign in with your authenticator code" on a screen with no code box
 * and no way to sign out. Element's owner hit exactly that on 2026-10-01.
 */

import type { MfaStatus } from './api.ts';

export type MfaRefusalStep =
  /** No authenticator yet: set one up here. */
  | 'enrol'
  /** An authenticator exists but this session has not used it: ask for a code. */
  | 'code'
  /** Nothing the picker can resolve (status unreadable, or already satisfied). */
  | 'message';

export function mfaRefusalStep(status: MfaStatus | null): MfaRefusalStep {
  if (status === null) return 'message';
  if (!status.enrolled) return 'enrol';
  if (!status.satisfiedForSession) return 'code';
  return 'message';
}
